import { render } from "./editPaysage.vue?vue&type=template&id=6352f280&scoped=true"
import script from "./editPaysage.vue?vue&type=script&lang=js"
export * from "./editPaysage.vue?vue&type=script&lang=js"

import "./editPaysage.vue?vue&type=style&index=0&id=6352f280&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6352f280"]])

export default __exports__